import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './topbar_button.scss'

class TopbarButton extends PureComponent {

	render() {
		return (
			<button
				styleName={classNames({
					wrapper: true,
					'wrapper--active': this.props.isActive,
				})}
				onClick={this.props.buttonHandler}
			>
				{!this.props.shouldUpdateCreateLesson &&
					<Fragment>
						<img styleName='icon' src={this.props.icon} alt={this.props.label} />
						<label styleName='label'>{this.props.label}</label>
					</Fragment>
				}
				{this.props.shouldUpdateCreateLesson &&
					<Fragment>
						<label styleName='label label--create'>
							{this.props.label}
						</label>
						<img styleName='icon icon--create' src={this.props.icon} alt={this.props.label} />
					</Fragment>
				}
			</button>
		)
	}
}

TopbarButton.defaultProps = {
	isActive: false,
	shouldUpdateCreateLesson: false,
}

TopbarButton.propTypes = {
	label: PropTypes.string.isRequired,
	icon: PropTypes.string.isRequired,
	buttonHandler: PropTypes.func.isRequired,
	isActive: PropTypes.bool,
	shouldUpdateCreateLesson: PropTypes.bool,
}

export default CSSModules(TopbarButton, styles, {allowMultiple: true})
